exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.checkout-label[data-v-2b591573]{\n    text-align: right;\n    width: 105px;\n}\n.billed-amount[data-v-2b591573] {\n    margin-left: 20px;\n    text-align: center;\n    border-bottom: 1px solid;\n    padding: 0 10px;\n    min-width: 160px;\n}\n.payment-method-btn span[data-v-2b591573] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.payment-method-btn span input[data-v-2b591573]{\n    position: absolute;\n    clip: rect(0,0,0,0);\n}\n", ""]);

// exports
